import classNames from "classnames";
import { Memo } from "../../../lib/api/models";
import { formatInCentralTime } from "../../../lib/formatting";
import styles from "./MemoHistory.module.css";
import { useMemo } from "react";

const strings = {
  fdrCode: "FDR Code",
};

type Props = {
  memos: Memo[];
  className?: string;
  header?: string;
};

export default function MemoHistory({ memos, className, header }: Props) {
  const sortedHistory = useMemo(() => {
    const sorted = [...memos];
    sorted.sort((a, b) => {
      if (b.createDate < a.createDate) {
        return -1;
      } else if (b.createDate > a.createDate) {
        return 1;
      }
      return 0;
    });
    return sorted;
  }, [memos]);

  return (
    <div className={classNames(styles.container, className)}>
      {header ? <div className={styles.header}>{header}</div> : null}
      <div className={styles.memoContainer}>
        {sortedHistory.map((memo) => (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          <div className={styles.memo} key={memo.id} tabIndex={0}>
            <span
              className={styles.memoHeader}
            >{`${formatInCentralTime(memo.createDate, "MM/dd/yyyy")} - ${formatInCentralTime(memo.createDate, "hh:mm a zzz")} - ${strings.fdrCode} ${memo.enteredBy}`}</span>
            <span className={styles.memoBody}>{memo.note}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
